/**
 * 店铺仓枚举
 */

// 对接方式（0.直连、1.吉客云）
export enum StoreTypeEnum {
  /**
   * 直连
   */
  DIRECT = 0,
  /**
   * 吉客云
   */
  GJ = 1,
}
export enum StoreTypeEnumName  {
  DIRECT = '直连',
  GJ = '吉客云',
}


// 渠道类型（1.三方渠道、2.外卖渠道、3.自建渠道、4.门店渠道、5.其他渠道）
export enum ChannelTypeEnum {
  /**
   * 三方渠道
   */
  THIRD_PARTY = 1,
  /**
   * 外卖渠道
   */
  TAKEAWAY = 2,
  /**
   * 自建渠道
   */
  SELF_BUILT = 3,
  /**
   * 门店渠道
   */
  STORE = 4,
  /**
   * 其他渠道
   */
  OTHER = 5,
}
export enum ChannelTypeEnumName  {
  THIRD_PARTY = '三方渠道',
  TAKEAWAY = '外卖渠道',
  SELF_BUILT = '自建渠道',
  STORE = '门店渠道',
  OTHER = '其他渠道',
}

// 状态（0:草稿,1:启用,2:禁用）
export enum StatusEnum {
  /**
   * 草稿
   */
  DRAFT = 0,
  /**
   * 启用
   */
  ENABLE = 1,
  /**
   * 禁用
   */
  DISABLE = 2,
}
export enum StatusEnumName  {
  DRAFT = '草稿',
  ENABLE = '启用',
  DISABLE = '禁用',
}

//创建方式（1.手动创建、2.自动生成）
export enum CreatedWayEnum {
  /**
   * 手动创建
   */
  MANUAL = 1,
  /**
   * 自动生成
   */
  AUTO = 2,
}
export enum CreatedWayEnumName  {
  MANUAL = '手动创建',
  AUTO = '自动生成',
}